var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.735 2.51501L27.485 6.26501L24.6263 9.12501L20.8763 5.37501L23.735 2.51501ZM10 20H13.75L22.8588 10.8913L19.1087 7.14126L10 16.25V20Z",
    fill: "#C1C2D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 23.75H10.1975C10.165 23.75 10.1313 23.7625 10.0988 23.7625C10.0575 23.7625 10.0163 23.7512 9.97375 23.75H6.25V6.25H14.8088L17.3088 3.75H6.25C4.87125 3.75 3.75 4.87 3.75 6.25V23.75C3.75 25.13 4.87125 26.25 6.25 26.25H23.75C24.413 26.25 25.0489 25.9866 25.5178 25.5178C25.9866 25.0489 26.25 24.413 26.25 23.75V12.915L23.75 15.415V23.75Z",
    fill: "#C1C2D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsEdit);
export default __webpack_public_path__ + "static/media/bxs_edit.9344128116a8bb6ced5de19bd1c4d931.svg";
export { ForwardRef as ReactComponent };